import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import { MEDIA } from '../../styleUtils'

const ScButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
`

const ScButtonLink = styled.a`
  padding: 0.25rem 1rem;
  ${MEDIA.TABLET`padding: 0.5rem 1rem;`}
  border-radius: 1rem;
  background: ${props => props.colors.default};
  font-size: 0.6875rem;
  font-weight: 600;
  line-height: 1rem;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  text-decoration: none;

  &:hover {
    background: ${props => props.colors.hover};
  }

  &:active {
    background: ${props => props.colors.active};
  }
`

const MomLifeButton = props => {
  const { colors } = props

  return (
    <ScButtonContainer>
      <ScButtonLink href="https://cafemom.com/momlife" colors={colors}>
        Join Our
        <br />
        Community
      </ScButtonLink>
    </ScButtonContainer>
  )
}

MomLifeButton.propTypes = {
  colors: PropTypes.shape({
    default: PropTypes.string,
    active: PropTypes.string,
    hover: PropTypes.string,
  }).isRequired,
}

export default MomLifeButton
